module.exports = __webpack_public_path__ + "img/newsImg10.024ed834.png";